"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryQuery = exports.InventoryTransport = exports.DailyAssignmentStats = exports.PublicInventoryTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const container_type_1 = require("./container/container-type");
exports.PublicInventoryTransport = typebox_1.Type.Object({
    size: typebox_1.Type.Integer(),
    dailyStats: typebox_1.Type.Record(typebox_1.Type.String({ format: 'date' }), typebox_1.Type.Boolean()),
});
/**
 * Represents the statistics for container assignments on a specific date.
 *
 * @property {number} current - The current inventory aggregated from containers w/ container assignments
 * @property {number} out - The total number of container assignments with a start date on the given date.
 * @property {number} in - The total number of container assignments with an end date on the given date.
 * @property {number} end - The end inventory aggregated from the current inventory and then subtracting delivery and adding pickup.
 */
exports.DailyAssignmentStats = typebox_1.Type.Object({
    current: typebox_1.Type.Integer(),
    out: typebox_1.Type.Integer(),
    in: typebox_1.Type.Integer(),
    end: typebox_1.Type.Integer(),
});
/**
 * Defines the structure for mapping each date to its container assignment statistics,
 * specifically for a given container type identified by a UUID.
 *
 * @property {string} containerTypeID - A UUID string that uniquely identifies the container type.
 * @property {Record<string, typeof DateStats>} dailyStats - A record where each key is a date in 'YYYY-MM-DD' format and the value is an object of type `DateStats` containing the statistics for that date.
 */
exports.InventoryTransport = typebox_1.Type.Object({
    containerTypeID: typebox_1.Type.String({ format: 'uuid' }),
    totalInventory: typebox_1.Type.Integer(),
    deliveredInventory: typebox_1.Type.Integer(),
    oosInventory: typebox_1.Type.Integer(),
    dailyStats: typebox_1.Type.Record(typebox_1.Type.String({ format: 'date' }), exports.DailyAssignmentStats),
});
/**
 * Represents a query object for inventory.
 *
 * @property {string} startDate - The start date to retrieve inventory.
 * @property {number} numDays - The number of days after the start date to return inventory for.
 * @property {ContainerType} containerStyle - The container style to filter by. (Optional)
 */
exports.InventoryQuery = typebox_1.Type.Object({
    startDate: typebox_1.Type.String({ format: 'date' }),
    numDays: typebox_1.Type.Integer(),
    containerStyle: typebox_1.Type.Optional(container_type_1.ContainerType),
});
//# sourceMappingURL=inventory-transport.js.map